import { InvoicesOrderBy } from 'common/types/globalTypes';
import { OrderDirection, SortOrder } from 'common/utils/commonTypes';

type OrderLookup = {
  [direction in OrderDirection]: InvoicesOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'type',
    {
      [OrderDirection.ASC]: [
        'INVOICE_TRANSACTION_TYPE_BY_TRANSACTION_TYPE_ID__TRANSACTION_TYPE_ASC',
      ],
      [OrderDirection.DESC]: [
        'INVOICE_TRANSACTION_TYPE_BY_TRANSACTION_TYPE_ID__TRANSACTION_TYPE_DESC',
      ],
    },
  ],
  [
    'vendorReference',
    {
      [OrderDirection.ASC]: ['VENDOR_REFERENCE_ASC'],
      [OrderDirection.DESC]: ['VENDOR_REFERENCE_DESC'],
    },
  ],
  [
    'description',
    {
      [OrderDirection.ASC]: ['DESCRIPTION_ASC'],
      [OrderDirection.DESC]: ['DESCRIPTION_DESC'],
    },
  ],
  [
    'invoiceNumber',
    {
      [OrderDirection.ASC]: ['INVOICE_NUMBER_ASC'],
      [OrderDirection.DESC]: ['INVOICE_NUMBER_DESC'],
    },
  ],
  [
    'invoiceDate',
    {
      [OrderDirection.ASC]: ['INVOICE_DATE_ASC'],
      [OrderDirection.DESC]: ['INVOICE_DATE_DESC'],
    },
  ],
  [
    'amount',
    {
      [OrderDirection.ASC]: ['CONTROL_TOTAL_AMOUNT_ASC'],
      [OrderDirection.DESC]: ['CONTROL_TOTAL_AMOUNT_DESC'],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder): InvoicesOrderBy[] => {
  const orderByArray: InvoicesOrderBy[] = ['PRIMARY_KEY_ASC'];
  if (!sort) return orderByArray;
  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return [...(orderBy ? orderBy : []), ...orderByArray];
};
